export function newsFilter() {
    let appliedFiltersContainer = $(".applied-filters");
    let appliedFilters = appliedFiltersContainer.find(".filters-list");
    let resetAllFiltersButton = $(".clear-filters");

    if (!appliedFilters.hasClass("empty")) {
        let filters = appliedFilters.find(".item");

        filters.find(".clear-filter").on("click", function () {
            $(this).closest(".item").remove();
        });
        resetAllFiltersButton.on("click", function () {
            appliedFilters.find(".item").remove();
            appliedFiltersContainer.addClass("empty").hide();
        });

        $(document).on('click', '.clear-filter', function (event) {
            let elementVal = $(this).parents('.item').find('.filter-title').text();
            $(this).parents('.item').remove();
            if ($('.filters-list li').length < 1) {
                appliedFiltersContainer.hide();
            }
            $('.select-filter option:selected').each(function (index, el) {
                if (elementVal == $(el).val()) {
                    $(el).prop('selected', false);
                    jcf.replaceAll();
                    return false;
                }
            });
        });
    }

    let selectElements = $('.select-filter');

    function filtered(selector) {
        let flag = 0;
        $(selector).each(function (index, el) {
            let selectedLength = $(el).val().length;
            let selectedArray = $(el).val();

            if (selectedLength) {
                flag = 1;
            }
            if (flag) {
                appliedFiltersContainer.removeClass('empty');
                selectedArray.forEach(function (item, i, arr) {
                    $(appliedFilters).html('');
                    setTimeout(function () {
                        let selectedOption = "\n                  <li class=\"item\">\n                  <span class=\"filter-title\">" + item + "</span>\n                  <button class=\"clear-filter\" type=\"button\"><svg width=\"10\" height=\"9\" viewBox=\"0 0 10 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                            "<path d=\"M0.650149 0.150147C0.850346 -0.0500491 1.17493 -0.0500491 1.37512 0.150147L9.34985 8.12488C9.55005 8.32507 9.55005 8.64966 9.34985 8.84985C9.14966 9.05005 8.82507 9.05005 8.62488 8.84985L0.650149 0.875123C0.449953 0.674927 0.449953 0.350344 0.650149 0.150147Z\" fill=\"#133440\"/>\n" +
                            "<path d=\"M9.34985 0.150147C9.14965 -0.0500491 8.82507 -0.0500491 8.62488 0.150147L0.650147 8.12488C0.449951 8.32507 0.449951 8.64966 0.650147 8.84985C0.850344 9.05005 1.17493 9.05005 1.37512 8.84985L9.34985 0.875123C9.55005 0.674927 9.55005 0.350344 9.34985 0.150147Z\" fill=\"#133440\"/>\n" +
                            "</svg>\n</button>\n                  </li>\n                  ";
                        $(selectedOption).appendTo(appliedFilters);
                    }, 100);
                });
                appliedFiltersContainer.show();
            } else {
                appliedFiltersContainer.hide();
            }
        });
    }

    filtered(selectElements);
    $(selectElements).on('change', function (event) {
        filtered(selectElements);
    });

    window.addEventListener("load", function () {
        let $holder = $('.holder-news-list');

        function pagination() {
            $('.holder-news-list').on('click', '.wp-pagenavi a', function (e) {
                e.preventDefault();

                let data = $('#news-filter').serialize();
                let paged = $(this).attr('data-paged');

                if (paged > 0) {
                    $.ajax({
                        url: ajaxvars.ajaxurl,
                        data: {
                            action: 'filter_news',
                            data: data,
                            paged: paged
                        },
                        type: "POST",
                        success: function success(response) {
                            $holder.html(response.content);
                            window.initPagination();
                            $("html, body").animate({scrollTop: $('.news-holder').offset().top - $('.header').innerHeight() * 1.5}, 500);
                        }
                    });
                }
            });
        }

        $('#news-filter').on('change', 'select', function (e) {
            let data = $('#news-filter').serialize();
            $.ajax({
                url: ajaxvars.ajaxurl,
                data: {
                    action: 'filter_news',
                    data: data,
                    paged: 1
                },
                type: 'POST',
                success: function success(response) {
                    $holder.html(response.content);
                    pagination();
                    window.initPagination();
                }
            });
        });

        $('.filters-list').on('click', '.clear-filter', function () {
            setTimeout(function () {
                let data = $('#news-filter').serialize();
                $.ajax({
                    url: ajaxvars.ajaxurl,
                    data: {
                        action: 'filter_news',
                        data: data,
                        paged: 1
                    },
                    type: 'POST',
                    success: function success(response) {
                        $holder.html(response.content);
                        pagination();
                        window.initPagination();
                    }
                });
            }, 700);
        });

        $('.news-filters').on('click', '.clear-filters', function () {
            let data = '';
            $.ajax({
                url: ajaxvars.ajaxurl,
                data: {
                    action: 'filter_news',
                    data: data,
                    paged: 1
                },
                type: 'POST',
                success: function success(response) {
                    $holder.html(response.content);
                    pagination();
                    window.initPagination();
                }
            });
        });

        pagination();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/newsFilter.js